"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyHeaderTitleFromIntl = exports.resolveLocale = exports.withIntl = exports.createIntlMock = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var messagesMap_1 = require("./messagesMap");
var Locale_1 = require("./Locale");
var wrapDisplayName_1 = require("../react/wrapDisplayName");
/**
 * @internal
 */
function createIntlMock(customMessages, locale) {
    if (customMessages === void 0) { customMessages = {}; }
    if (locale === void 0) { locale = "en-US"; }
    return react_intl_1.createIntl({
        locale: locale,
        messages: tslib_1.__assign(tslib_1.__assign({}, messagesMap_1.messagesMap[locale]), customMessages),
    });
}
exports.createIntlMock = createIntlMock;
/**
 * @internal
 */
function withIntl(WrappedComponent, customLocale, customMessages) {
    var WithIntl = /** @class */ (function (_super) {
        tslib_1.__extends(WithIntl, _super);
        function WithIntl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithIntl.prototype.render = function () {
            var locale = customLocale ? customLocale : Locale_1.DefaultLocale;
            var messages = customMessages ? customMessages : messagesMap_1.messagesMap[locale];
            return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: messages },
                react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, this.props))));
        };
        return WithIntl;
    }(react_1.default.Component));
    return wrapDisplayName_1.wrapDisplayName("withIntl", WrappedComponent)(WithIntl);
}
exports.withIntl = withIntl;
/**
 * Resolves parameter into {@link ILocale} or {@link DefaultLocale}.
 *
 * @param locale - value of the locale to check for support
 *
 * @internal
 */
exports.resolveLocale = function (locale) {
    return Locale_1.isLocale(locale) ? locale : Locale_1.DefaultLocale;
};
/**
 * Returns a string meant to represent a header with an empty value.
 * @param intl - the source of i18n strings
 * @internal
 */
function emptyHeaderTitleFromIntl(intl) {
    return "(" + intl.formatMessage({ id: "visualization.emptyValue" }) + ")";
}
exports.emptyHeaderTitleFromIntl = emptyHeaderTitleFromIntl;
//# sourceMappingURL=intlUtils.js.map